import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=4868be18&"
import script from "./Resource.vue?vue&type=script&lang=js&"
export * from "./Resource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports